import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _without from "lodash-es/without";
import _isNil from "lodash-es/isNil";
import cx from 'clsx';
import React, { Component } from 'react';
import { childrenUtils, createHTMLParagraph, customPropTypes, getElementType, getUnhandledProps, SUI, useKeyOnly, useKeyOrValueAndKey } from '../../lib';
import Icon from '../../elements/Icon';
import MessageContent from './MessageContent';
import MessageHeader from './MessageHeader';
import MessageList from './MessageList';
import MessageItem from './MessageItem';
/**
 * A message displays information that explains nearby content.
 * @see Form
 */

var Message = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Message, _Component);
  function Message() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleDismiss = function (e) {
      var onDismiss = _this.props.onDismiss;
      if (onDismiss) onDismiss(e, _this.props);
    };
    return _this;
  }
  var _proto = Message.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      attached = _this$props.attached,
      children = _this$props.children,
      className = _this$props.className,
      color = _this$props.color,
      compact = _this$props.compact,
      content = _this$props.content,
      error = _this$props.error,
      floating = _this$props.floating,
      header = _this$props.header,
      hidden = _this$props.hidden,
      icon = _this$props.icon,
      info = _this$props.info,
      list = _this$props.list,
      negative = _this$props.negative,
      onDismiss = _this$props.onDismiss,
      positive = _this$props.positive,
      size = _this$props.size,
      success = _this$props.success,
      visible = _this$props.visible,
      warning = _this$props.warning;
    var classes = cx('ui', color, size, useKeyOnly(compact, 'compact'), useKeyOnly(error, 'error'), useKeyOnly(floating, 'floating'), useKeyOnly(hidden, 'hidden'), useKeyOnly(icon, 'icon'), useKeyOnly(info, 'info'), useKeyOnly(negative, 'negative'), useKeyOnly(positive, 'positive'), useKeyOnly(success, 'success'), useKeyOnly(visible, 'visible'), useKeyOnly(warning, 'warning'), useKeyOrValueAndKey(attached, 'attached'), 'message', className);
    var dismissIcon = onDismiss && /*#__PURE__*/React.createElement(Icon, {
      name: "close",
      onClick: this.handleDismiss
    });
    var rest = getUnhandledProps(Message, this.props);
    var ElementType = getElementType(Message, this.props);
    if (!childrenUtils.isNil(children)) {
      return /*#__PURE__*/React.createElement(ElementType, _extends({}, rest, {
        className: classes
      }), dismissIcon, children);
    }
    return /*#__PURE__*/React.createElement(ElementType, _extends({}, rest, {
      className: classes
    }), dismissIcon, Icon.create(icon, {
      autoGenerateKey: false
    }), (!_isNil(header) || !_isNil(content) || !_isNil(list)) && /*#__PURE__*/React.createElement(MessageContent, null, MessageHeader.create(header, {
      autoGenerateKey: false
    }), MessageList.create(list, {
      autoGenerateKey: false
    }), createHTMLParagraph(content, {
      autoGenerateKey: false
    })));
  };
  return Message;
}(Component);
Message.handledProps = ["as", "attached", "children", "className", "color", "compact", "content", "error", "floating", "header", "hidden", "icon", "info", "list", "negative", "onDismiss", "positive", "size", "success", "visible", "warning"];
export { Message as default };
Message.Content = MessageContent;
Message.Header = MessageHeader;
Message.List = MessageList;
Message.Item = MessageItem;